export class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.onSwatchClick = this.onSwatchClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('.color-swatch').forEach((swatch) => {
      swatch.addEventListener('click', this.onSwatchClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('.color-swatch').forEach((swatch) => {
      swatch.removeEventListener('click', this.onSwatchClick);
    });
  }

  onSwatchClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const swatch = event.currentTarget;
    const productImage = this.querySelector('[data-product-image]');
    const mediaLink = this.querySelector('[data-product-card-link]');
    const titleLink = this.querySelector('[data-product-card-title-link]');
    const titlePrimary = this.querySelector('[data-product-card-title-primary]');
    const titleSecondary = this.querySelector('[data-product-card-title-secondary]');
    const priceEl = this.querySelector('[data-product-card-price]');
    const variantInput = this.querySelector('[data-product-card-variant-id]');
    const atcButton = this.querySelector('[data-product-card-atc-button]');
    const mediaChild = this.querySelector('.card-media-child');

    this.querySelectorAll('.color-swatch').forEach((s) => {
      s.classList.remove('selected', 'is-selected');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('selected', 'is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    const imageUrl = swatch.dataset.imageUrl;
    const imageSrcset = swatch.dataset.imageSrcset;
    const swatchImageElement = swatch.querySelector('.data-variant-image');

    let newImageUrl = imageUrl || null;
    let newSrcset = imageSrcset || null;

    if (!newImageUrl && swatchImageElement) {
      newImageUrl = swatchImageElement.getAttribute('src');
      newSrcset = swatchImageElement.getAttribute('srcset');
    }

    if (!newImageUrl) {
      newImageUrl = swatch.getAttribute('src');
      newSrcset = swatch.getAttribute('srcset');
    }

    if (productImage && newImageUrl) {
      productImage.src = newImageUrl;
      if (newSrcset) {
        productImage.srcset = newSrcset;
      } else {
        productImage.removeAttribute('srcset');
      }
    }

    const secondaryUrl = swatch.dataset.secondaryImageUrl;
    const secondarySrcset = swatch.dataset.secondaryImageSrcset;
    let secondaryImage = this.querySelector('[data-product-image-secondary]');

    if (secondaryUrl) {
      if (!secondaryImage && mediaChild) {
        secondaryImage = document.createElement('img');
        secondaryImage.className = 'product-card__image product-card__image--secondary';
        secondaryImage.setAttribute('data-product-image-secondary', '');
        secondaryImage.loading = 'lazy';
        mediaChild.appendChild(secondaryImage);
      }
      if (secondaryImage) {
        secondaryImage.src = secondaryUrl;
        if (secondarySrcset) secondaryImage.srcset = secondarySrcset;
        secondaryImage.alt = swatch.dataset.secondaryImageAlt || '';
        secondaryImage.hidden = false;
        secondaryImage.removeAttribute('hidden');
        this.classList.add('product-card--hover-image');
        mediaChild?.classList.add('card-media-child--hover');
      }
    } else if (secondaryImage) {
      secondaryImage.remove();
      this.classList.remove('product-card--hover-image');
      mediaChild?.classList.remove('card-media-child--hover');
    }

    const href = swatch.dataset.href;
    if (href) {
      if (mediaLink) mediaLink.setAttribute('href', href);
      if (titleLink) titleLink.setAttribute('href', href);
    }

    const relatedProductId = swatch.dataset.relatedProductId;
    if (relatedProductId) {
      this.dataset.productId = relatedProductId;
      if (productImage) productImage.setAttribute('data-product-image', relatedProductId);
    }

    if (titlePrimary && swatch.dataset.titlePrimary) {
      titlePrimary.textContent = swatch.dataset.titlePrimary;
    }

    const titleLinkEl = this.querySelector('[data-product-card-title-link]');
    const secondaryText = swatch.dataset.titleSecondary || '';
    if (titleSecondary) {
      titleSecondary.textContent = secondaryText;
      titleSecondary.hidden = !secondaryText;
      if (!secondaryText) titleSecondary.remove();
    } else if (secondaryText && titleLinkEl) {
      const secondaryEl = document.createElement('span');
      secondaryEl.className = 'product-card__title-secondary text-caption';
      secondaryEl.setAttribute('data-product-card-title-secondary', '');
      secondaryEl.textContent = secondaryText;
      titleLinkEl.appendChild(secondaryEl);
    }

    if (productImage && swatch.dataset.imageAlt !== undefined) {
      productImage.alt = swatch.dataset.imageAlt;
    }

    if (variantInput && swatch.dataset.variantId) {
      variantInput.value = swatch.dataset.variantId;
      const available = swatch.dataset.available !== 'false';
      variantInput.disabled = !available;
      if (atcButton) {
        atcButton.disabled = !available;
        const addToCartLabel =
          this.dataset.labelAddToBag || this.dataset.labelAddToCart || 'Add to cart';
        const soldOutLabel = this.dataset.labelSoldOut || 'Sold out';
        const ariaLabel = available ? addToCartLabel : soldOutLabel;
        atcButton.setAttribute('aria-label', ariaLabel || addToCartLabel || 'Add to cart');
      }
    }

    if (priceEl && swatch.dataset.price) {
      const compare = swatch.dataset.comparePrice;
      const showFrom = (swatch.dataset.priceVaries || this.dataset.priceVaries) === 'true';
      const fromLabel = this.dataset.priceFrom || 'From';
      const fromMarkup = showFrom
        ? `<span class="price-item price-item--from">${fromLabel}</span>`
        : '';
      if (compare) {
        priceEl.innerHTML = `
          <div class="price text-price-sm price--on-sale">
            <div class="price__container">
              <div class="price__regular"></div>
              <div class="price__sale">
                ${fromMarkup}
                <span class="price-item price-item--sale">${swatch.dataset.price}</span>
                <span class="price-item price-item--regular text-price-compare">${compare}</span>
              </div>
            </div>
          </div>
        `;
      } else {
        priceEl.innerHTML = `
          <div class="price text-price-sm">
            <div class="price__container">
              <div class="price__regular">
                ${fromMarkup}
                <span class="price-item price-item--regular">${swatch.dataset.price}</span>
              </div>
            </div>
          </div>
        `;
      }
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}